import { makeThemeColor, PRIMARY, SECONDARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  bar: makeThemeColor(SECONDARY),
};

export const HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const BAR_WIDTH = {
  [HD]: 3,
  [FULL_HD]: 4,
};

export const GAP = {
  [HD]: 1,
  [FULL_HD]: 2,
};

const getWidth = screenSize => 4 * (BAR_WIDTH[screenSize] + GAP[screenSize]) - GAP[screenSize];

export const WIDTH = {
  [HD]: getWidth(HD),
  [FULL_HD]: getWidth(FULL_HD),
};

export const getInitialStyle = ({ screenSize } = defaultContext) => ({
  h: HEIGHT[screenSize],
});
